// 1. Sinh chuỗi ngẫu nhiên (Code Verifier)
export function generateCodeVerifier() {
  const array = new Uint32Array(56);
  window.crypto.getRandomValues(array);
  return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join("");
}

// 2. Chuyển đổi chuỗi sang mã hóa Base64URL
function sha256(plain: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
}

function base64urlencode(str: ArrayBuffer): string {
  return btoa(String.fromCharCode(...new Uint8Array(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

// 3. Tạo Code Challenge từ Code Verifier
export async function generateCodeChallenge(verifier: string) {
  const hashed = await sha256(verifier);
  return base64urlencode(hashed);
}
